/**
 * The "Changed by Copilot" tag on a form field (LP-402). id: the change that tagged it (falsy: no tag).
 * source (LP-403): 'meeting' ("From the meeting") or 'web' ("From the web: check this") for facts a
 * partner accepted from a meeting; otherwise the Copilot's own tag.
 * Render it with key={id} so a second change to the same field flashes again.
 */
const SOURCES = {
  meeting: ['From the meeting', 'qb-flash inline-block whitespace-nowrap rounded-md bg-green-100 px-1.5 py-0.5 text-[11px] font-medium text-green-800 dark:bg-green-900/40 dark:text-green-200'],
  web: ['From the web: check this', 'qb-flash inline-block whitespace-nowrap rounded-md bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-900 dark:bg-amber-900/40 dark:text-amber-200'],
};
export function Changed({ id, source = null }) {
  if (!id) return null;
  if (SOURCES[source]) return <span className={SOURCES[source][1]}>{SOURCES[source][0]}</span>;
  return <span className="qb-flash inline-block whitespace-nowrap rounded-md bg-sky-100 px-1.5 py-0.5 text-[11px] font-medium text-sky-800 dark:bg-sky-900/50 dark:text-sky-200">Changed by Copilot</span>;
}

/** The ring around a field the Copilot changed. */
export const changedRing = (id) => (id ? 'ring-2 ring-sky-300 dark:ring-sky-700' : '');
